<template>
  <div class="over-page">
    <main>
      <div class="frame mid">
        <div class="modal-content-wrapper">
          <header class="page-title">
            <h3>Novo Público</h3>
            <a href="#" class="btn btn-secondary">Ver todos</a>
          </header>
          <div class="modal-body">
            <div class="row" ref="filter">
              <div class="col-12 form-group">
                <input-control 
                  required 
                  placeholder="Público ABC" 
                  label="Nome" 
                  name="nome" 
                  v-model="filter.nome"
                />
              </div>
              <div class="col-md-6 form-group">
                <select-control 
                  required 
                  :options="options.unidades" 
                  placeholder="Selecione" 
                  label="Unidade" 
                  name="idUnidade" 
                  v-model="filter.idUnidade" 
                  @change="getPeriodosLetivos"
                  :disabled="loadingContent"
                />
              </div>
              <div class="col-md-2 form-group">
                <select-control 
                  required 
                  :options="options.periodosLetivos" 
                  placeholder="Selecione" 
                  label="Período Letivo" 
                  name="idPeriodoLetivo" 
                  v-model="filter.idPeriodoLetivo"
                  :disabled="loadingContent"
                  @change="getCursos(); getSeries()"
                />
              </div>
              <div class="col-md-4 form-group">
                <select-control 
                  :options="options.cursos" 
                  placeholder="Selecione" 
                  label="Curso" 
                  name="idCurso"
                  v-model="filter.idCurso"
                  :disabled="loadingContent"
                  @change="filterSeries"
                />
              </div>
              <div class="col-md-4 form-group">
                <select-control 
                  :options="options.series" 
                  placeholder="Selecione" 
                  label="Série" 
                  name="serie" 
                  v-model="filter.idSerie"
                  :disabled="loadingContent"
                  @change="getTurmas"
                />
              </div>
              <div class="col-md-4 form-group">
                <select-control 
                  :options="options.turmas" 
                  placeholder="Selecione" 
                  label="Turma" 
                  name="turma"
                  v-model="filter.idTurma"
                  :disabled="loadingContent" 
                />
              </div>
              <div class="col-md-4 form-group action">
                <a href="#" class="btn btn-primary" @click.prevent="listarAlunos">Listar Alunos</a>
              </div>
            </div>
            <section class="exchangePanel panel-section">
              <div>
                <header>
                  <div>
                    <p>
                      <b>
                        {{ alunosDisponiveis.length }} itens disponíveis
                      </b>
                    </p>
                    <a href="#" class="btn btn-secondary btn-small" @click.prevent="selecionarTudo()">
                      Selecionar Tudo
                    </a>
                  </div>
                  <div class="search-box">
                    <fa :icon="['far','magnifying-glass']" class="ic"/>
                    <input type="text" placeholder="O que você procura?" />
                  </div>
                </header>
                <div>
                  <ul>
                    <li v-for="aluno in alunosDisponiveis" :key="aluno.id" @click.prevent="selecionarAluno(aluno)">
                      <span>{{ aluno.nome }}</span>
                      <fa :icon="['fal','arrow-right-long']" class="ic"/>
                    </li>
                  </ul>
                </div>
              </div>
              <div>
                <header>
                  <div>
                    <p>
                      <b>
                        {{ alunosSelecionados.length }} itens selecionados
                      </b>
                    </p>
                    <a href="#" class="btn btn-secondary btn-small" @click.prevent="removerTudo()">
                      Remover Tudo
                    </a>
                  </div>
                  <div class="search-box">
                    <fa :icon="['far','magnifying-glass']" class="ic"/>
                    <input type="text" placeholder="O que você procura?" />
                  </div>
                </header>
                <div>
                  <ul>
                    <li v-for="aluno in alunosSelecionados" :key="aluno.id" @click.prevent="removerAluno(aluno)">
                      <span>{{ aluno.nome }}</span>
                      <fa :icon="['fal','arrow-left-long']" class="ic"/>
                    </li>
                  </ul>
                </div>
              </div>
            </section>
          </div>
          <footer>
            <a href="#" class="btn btn-secondary" @click.prevent="fecharModal">Voltar</a>
            <a href="#" class="btn btn-primary" @click.prevent="salvar">Salvar</a>
          </footer>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import UserService from '@/services/user.service.js'
import AcademicoService from '@/services/academico.service'
import NegociaService from '@/services/negocieja.service.js'
import { createSelectOptions } from '@/services/utils.service.js'

export default {
  name: 'NovoPublico',
  data() {
    return {
      filter: {
        nome: '',
        idUnidade: null,
        idPeridoLetivo: null,
        idCurso: null,
        idSerie: null,
        isTurma: null,
      },
      series: null,
      options: {
        unidades: [],
        periodosLetivos: [],
        cursos: [],
        series: [],
        turmas: [],
      },
      loadingContent: false,
      alunosDisponiveis: [],
      alunosSelecionados: [],
      wait: {
        cursos: false,
        series: false
      }
    }
  },
  created() {
    this.getUnidades()
  },
  methods: {
    getUnidades () {
      this.loadingContent = true
      UserService.getUnidades().then(response => {
        this.options.unidades = createSelectOptions(response.data, 'idUnidade', 'descricao')
        this.loadingContent = false
      }).catch(error => {
        console.error("Erro ao buscar unidades:", error)
        this.loadingContent = false
      })
    },
    getPeriodosLetivos() {
      this.loadingContent = true
      AcademicoService.getPeriodosLetivos(this.filter.idUnidade).then( response => {
          if (response.data.length > 0) {
            this.options.periodosLetivos = createSelectOptions(response.data, 'idPeriodoLetivo', 'descricao').reverse()
          } else {
            window.toaster.emit('open', {
              style: "error",
              message: "Nenhum período letivo encontrado. Isto parece ser um problema de parametrização.",
              floater: true
            })
          }
          this.loadingContent = false
        }
      ).catch( error => {
        console.error("Erro ao buscar unidades:", error)
        this.loadingContent = false
      })
    },
    getCursos() {
      this.loadingContent = true
      const { idUnidade, idPeridoLetivo } = this.filter

      AcademicoService.getCursos( idUnidade, idPeridoLetivo ).then(response => {
        this.options.cursos = createSelectOptions(response.data,'idCurso', 'descricao')
        this.wait.cursos = true
        this.finishLoad()
      }).catch(error => {
        window.toaster.emit('open', {
          style: "error",
          message: "Ops. Algo Aconteceu! Não foi possível encontrar cursos com os parâmetros informados. " + error,
          floater: true
        })
        this.loadingContent = false
      })
    },
    getSeries() {
      this.loadingContent = true
      const { idPeriodoLetivo } = this.filter
      AcademicoService.getSeries( idPeriodoLetivo ).then(response => {
        const series = response.data.map( k => {
          return {
            ...k,
            tag: `${k.descricao}/${k.descricaoTurno}`
          }
        })
   
        this.options.series = createSelectOptions(series, 'idSerie', 'tag')
        this.series = series

        this.wait.series = true
        this.finishLoad()
      }).catch(error => {
        window.toaster.emit('open', {
          style: "error",
          message: "Ops. Algo Aconteceu! Não foi possível encontrar series com os parâmetros informados. " + error,
          floater: true
        })
        this.loadingContent = false
      })
    },
    filterSeries () {
      this.loadingContent = true

      const filtered = this.series.filter( a => a.idCurso == this.filter.idCurso)
      this.options.series = createSelectOptions(filtered, 'idSerie', 'tag')

      this.loadingContent = false
    },
    getTurmas() {
      this.loadingContent = true
      const { idSerie } = this.filter
      AcademicoService.getTurmas(idSerie).then(response => {
        console.log("getTurmas:", response.data)

        this.options.turmas = createSelectOptions(response.data,'idTurma','descricao')
        this.loadingContent = false
      }).catch(error => {
        window.toaster.emit('open', {
          style: "error",
          message: "Ops. Algo Aconteceu! Não foi possível encontrar series com os parâmetros informados. " + error,
          floater: true
        })
        this.loadingContent = false
      })
    },
    finishLoad () {
      const done = !Object.values(this.wait).some( a => !a)
      console.log("finishLoad:", done)

      if ( done ) {
        this.loadingContent = false
      }
    },
    fecharModal() {
      this.$emit('fechar')
    },
    listarAlunos() {
      const siglaUnidade = this.options.unidades.filter( a => a.idUnidade == this.filter.idUnidade)[0].sigla
      const periodoLetivo = this.options.periodosLetivos.filter( a => a.idPeriodoLetivo == this.filter.idPeriodoLetivo)[0].descricao
      const serie = this.filter.idSerie ? this.options.series.filter( a => a.idSerie == this.filter.idSerie)[0].descricao : 0

      console.log('serie', serie)
      const { idCurso, idTurma } = this.filter

      const options = {
        siglaUnidade,
        periodoLetivo,
        idCurso, 
        serie, 
        idTurma
      }

      console.log("options:", options)
      NegociaService.getAlunosFiltrados(options)
        .then((response) => {
          this.alunosDisponiveis = (response.data || []).map(aluno => ({
            id: aluno.idAluno,
            nome: aluno.nomeDocumento
          }));
        })
        .catch((error) => {
          console.error("Erro ao buscar alunos:", error.response?.data || error.message);
          window.toaster.emit('open', {
            style: "error",
            message: "Erro ao buscar alunos. Verifique os filtros.",
            floater: true
          });
        })
        .finally(() => {
          this.loadingAlunos = false;
        });
    },
    selecionarAluno(alunoParaSelecionar) {
      this.alunosSelecionados.push(alunoParaSelecionar);
      this.alunosDisponiveis = this.alunosDisponiveis.filter(
        aluno => aluno.id !== alunoParaSelecionar.id
      );
    },
    removerAluno(alunoParaRemover) {
      this.alunosDisponiveis.push(alunoParaRemover);
      this.alunosSelecionados = this.alunosSelecionados.filter(
        aluno => aluno.id !== alunoParaRemover.id
      );
    },
    selecionarTudo() {
      this.alunosSelecionados.push(...this.alunosDisponiveis);
      this.alunosDisponiveis = [];
    },
    removerTudo() {
      this.alunosDisponiveis.push(...this.alunosSelecionados);
      this.alunosSelecionados = [];
    },
    salvar() {
      const payload = {
        nome: this.filter.nome,
        alunos: this.alunosSelecionados.map(a => a.id)
      }
      console.log('Payload enviado:', payload)

      NegociaService.createPublico(payload)
        .then(() => {
          // this.$emit('fechar')
          this.fecharModal()
        })
        .catch(err => {
          window.toaster.emit('open', {
            style: 'error',
            message: 'Erro ao salvar público. ' + err,
            floater: true
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>

.row {
  padding: $hmg_mid $mg_mini;
}

.modal-body {
    padding: 0 !important;
}

.page-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: $border-component;
  padding: $mg_small;
  
  h3 {
    color: $vermelho;
    margin: 0;                 
    line-height: 1;
  }
}

footer{
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: $hmg_small;
  border-bottom-left-radius: $border-radius;
  border-bottom-right-radius: $border-radius;
  background-color: $branco;
}

.action {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}
.panel-section{
  border: border-component;
  background-color: $branco;
}

.modal-content-wrapper {
  padding: 0 !important;
  margin-top: 2rem;
  margin-bottom: 2rem;
  background-color: $color-secondary;
  border-radius: $border-radius;
  border: $border-component;
  max-height: auto;
  display: flex;  
  flex-direction: column;
}

// .modal-body {
//   width: 100%;
// }
.exchangePanel {
    padding: 0 !important;
    margin: 0 !important;
    gap: 0 !important;
    width: 100%;
  > div {
    border-top: $border-component;
    border-bottom: $border-component;
    @extend %scrollbar_light_panel;
    overflow-y: auto;
    background-color: $branco;
    height: 100%;
    display: flex; 
    flex-direction: column;

    header {
      width: 100%;

      >div {
        position: relative;
        background-color: $branco;

        p {
          padding: 0; margin: 0;
        }

        &:first-child {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: $mg_mini $hmg_small;
        }

        &.search-box {
          background-color: $color-bg;
          border-top: $border-component;
          border-bottom: $border-component;
          height: 40px;

          input {
            background: transparent;
            padding: 0 $hmg_small;
            width: 100%; 
            height: 100%;
            border: 0; 
            box-shadow: none;
            font-size: $font-size-small;

            &::placeholder {
              color: $color-mid-grey;
            }
            &:focus {
              outline: none;
              box-shadow: none;
              border: 0;
            }
          }
          .ic {
            position: absolute;
            right: $hmg_small;
            top: 50%; transform: translateY(-50%);
          }
        }
      }
    }

    > div {
      flex: 1;
      overflow: auto;
      @extend %scrollbar_light_panel;

      ul {
        padding: 0; margin: 0;

        li {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: $mg_mini $hmg_small;
          list-style: none;
          border-bottom: $border-component;
          cursor: pointer;

          .ic {
            @extend %transition_3e;
          }

          &:hover {
            .ic {
              color: $color-primary;
            }
          }
        }
      }
    }
  }
}
</style>